<template>
  <main class="story-page">
    <HeroSection
      :summary="story.summary"
      :name="story.name"
      :position="story.position"
      :image="topImage"
    />
    <ContentSection
      :story-content="story.story"
      :other-stories="otherStories"
    />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import ContentSection from './ContentSection/ContentSection.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: {
    HeroSection,
    ContentSection,
  },
  props: {
    story: {
      type: Object,
      default: () => {},
    },
    otherStories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    topImage() {
      return this.story.top_image
        ? cloudinaryImage({ imagePath: this.story.top_image, width: 750 })
        : null;
    },
  },
};
</script>
